/* unplugin-vue-components disabled */import { render } from "./credit-card-payment.vue?vue&type=template&id=510ebeb8"
import script from "./credit-card-payment.vue?vue&type=script&lang=js"
export * from "./credit-card-payment.vue?vue&type=script&lang=js"

import "./credit-card-payment.vue?vue&type=style&index=0&id=510ebeb8&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__